import { Component, OnInit, Input,  } from '@angular/core';

@Component({
  selector: 'lc-ftu',
  templateUrl: './ftu.component.html',
  styleUrls: ['./ftu.component.scss']
})
export class FtuComponent implements OnInit {

  steps: [any] = ['step0.jpg','step1.jpg','step2.jpg','step3.jpg'];
  @Input() lang: string = 'nl';
  @Input() show: boolean = false;
  current_step: number = 0;

  constructor() { }

  ngOnInit() {

  }

  previous() {
    if (this.current_step > 0) { this.current_step --; }
  }

  next() {
    if (this.current_step < (this.steps.length - 1)) {
      this.current_step ++;
    }
  }

  closeFtu() {
    this.show = false;
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/ftu/ftu.component.ts